import * as api from '../util/apis';
import { ENV } from '../constants/Constants';

export const getContentLibraryData = async (clientId) => {
	try {
		const resp = await api.getapiresponses(
			`${ENV.dev.contentLibrary}?clientId=${clientId}`,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteContentLibraryData = async (clientId, data) => {
	try {
		const resp = await api.deleteapiDataresponses(
			`${ENV.dev.contentLibrary}?clientId=${clientId}`,
			data,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};
export const getContentFolders = async (clientId, foldersId) => {
	try {
		const resp = await api.getapiresponses(
			`${ENV.dev.contentLibraryFolders}/${foldersId}?clientId=${clientId}`,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createContentFolders = async (clientId, data) => {
	try {
		const resp = await api.postapiresponses(
			`${ENV.dev.contentLibraryFolders}?clientId=${clientId}`,
			data,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateContentFolders = async (clientId, foldersId, data) => {
	try {
		const resp = await api.putapiresponses(
			`${ENV.dev.contentLibraryFolders}/${foldersId}?clientId=${clientId}`,
			data,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};
export const deleteContentFolders = async (clientId, foldersId) => {
	try {
		const resp = await api.getapiresponses(
			`${ENV.dev.contentLibraryFolders}/${foldersId}?clientId=${clientId}`,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getContentFiles = async (clientId, fileId) => {
	try {
		const resp = await api.getapiresponses(
			`${ENV.dev.contentLibraryFiles}/${fileId}?clientId=${clientId}`,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createContentFiles = async (clientId, data) => {
	try {
		const resp = await api.postapiresponses(
			`${ENV.dev.contentLibraryFiles}?clientId=${clientId}`,
			data,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateContentFiles = async (clientId, fileId, data) => {
	try {
		const resp = await api.putapiresponses(
			`${ENV.dev.contentLibraryFiles}/${fileId}?clientId=${clientId}`,
			data,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};
export const deleteContentFiles = async (fileId) => {
	try {
		const resp = await api.getapiresponses(
			`${ENV.dev.contentLibraryFiles}/${fileId}`,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};
